import script from "./GlobalLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalLoader.vue?vue&type=script&setup=true&lang=ts"

import "./GlobalLoader.vue?vue&type=style&index=0&id=700c81ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-700c81ec"]])

export default __exports__